import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { DEFAULT_LANGUAGE_ID } from '../constants/commonenums';
 const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json', 'x-ts-client-uid': localStorage.getItem("ClientUid") ? localStorage.getItem("ClientUid") : '', 'Language-Id': (sessionStorage.getItem('languageId') || DEFAULT_LANGUAGE_ID).toString() })
};

const httpOptionsImage = {
  headers: new HttpHeaders({ responseType: 'text'})
};
@Injectable({
  providedIn: 'root'
}
)
export class HttpService {

  constructor(public http: HttpClient) {
  }

  get(path: string,forImage?:boolean):  Observable<any> {
    if(forImage)
    {
      return this.http.get(`${path}`, {responseType: 'text'}).pipe(map(response => response));  
    }
    else
    {
      return this.http.get(`${path}`, httpOptions).pipe(map(response => response));
    }
  }

  put(path: string, body: Object = {}): Observable<any> {
    return this.http.put(`${path}`,
      body,
      httpOptions
    ).pipe(map(response => response), catchError(this.handleError));
  }

  post(path: string, body: Object = {}): Observable<any> {
    return this.http.post(`${path}`,
      body,
      httpOptions
    ).pipe(map(response => response));
  }

  delete(path): Observable<any> {
    return this.http.delete(`${path}`, httpOptions
    ).pipe(map(response => response));
  }

  handleError(error: any) {
    let errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : "Server errorsssss";
    console.error(errMsg);
    return throwError(errMsg);
  }
}
